var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-main"},[_c('the-side-menu'),_c('router-view',{staticClass:"sub-view"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }